import React from 'react';
import gql from 'graphql-tag';
import { Mutation } from 'react-apollo';
import { useStoreState } from 'easy-peasy';
import { isNull } from 'lodash';
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import client from '../../../utils/apolloClient';

const deleteMutation = gql`
  mutation deleteMenu($input: NavigateMenuInput) {
    delete_menu(input: $input) {
      menu_id
      error {
        description
      }
    }
  }
`;

const GlobalMenuUpdate = ({ menuId }) => {
  const { userId } = useStoreState(state => state.auth);

  return (
    <Mutation
      client={client.clientPrivate}
      mutation={deleteMutation}
      onCompleted={({ delete_menu }) => {
        if (!isNull(delete_menu.error)) {
          delete_menu.error.map(item => toast.error(item.description));
        } else {
          toast.success('Menu deleted successfully!');
          window.location.reload(true);
        }
      }}
    >
      {(delete_menu, { loading }) => (
        <button
          className={`button ${loading && 'is-loading'}`}
          disabled
          onClick={() => {
            swal({
              title: 'Are you sure?',
              // eslint-disable-next-line max-len
              text: `Are you sure you want to delete this Menu`,
              buttons: ['Cancel', 'Yes'],
              dangerMode: true,
            }).then(willDelete => {
              if (willDelete) {
                delete_menu({
                  variables: {
                    input: {
                      user_id: userId,
                      menu_id: menuId,
                    },
                  },
                });
              }
            });
            // .finally(() => {
            //   window.location.href = '/menus';
            // });
          }}
        >
          <i className="fas fa-trash has-text-grey" id="DeleteMenuDesigner" />
        </button>
      )}
    </Mutation>
  );
};

export default GlobalMenuUpdate;
